
// This file is automatically generated. Do not edit it directly.
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/utils/supabaseConfig';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Environment variables VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required.'
  );
}

// Используем централизованную конфигурацию вместо жестко прописанных значений
export const SUPABASE_URL_CONFIG = SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY = SUPABASE_ANON_KEY;

// Экспортируем SUPABASE_URL для обратной совместимости
export { SUPABASE_URL, SUPABASE_ANON_KEY };

// Функция для получения конфигурации - используем централизованную конфигурацию
export const getSupabaseConfig = () => ({
  url: SUPABASE_URL,
  anonKey: SUPABASE_PUBLISHABLE_KEY
});

console.log('✅ Supabase URL из централизованной конфигурации:', SUPABASE_URL);
console.log('✅ ПРЯМОЕ подключение к Supabase (без прокси)');
